import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '@app/core/services';
import { HomeRoutes } from '@app/enums';

@Injectable()
export class AuthGuard {
	constructor(
		private readonly authService: AuthService,
		private readonly router: Router,
	) {}

	canActivate(): boolean | UrlTree {
		if (this.authService.isAuthenticated) {
			return true;
		}

		// Force the user to redirect to the login page when not authorized for the route.
		return this.router.createUrlTree([HomeRoutes.Login]); //, { queryParams: { returnUrl: state.url } }
	}
}
